<template>
  <div>
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>

    <div v-if="this.loadingFormSubmit == false" class="form-container">
      <el-card class="cont-card form-card">
        <h1>Delete Property</h1>
        <h4>This property contains {{ property.machinecount }} assets.</h4>
        <h4> All assets and work orders in property will get deleted </h4>
        <h4>Are you sure you want to delete?</h4>
        <h5>This action cannot be undone.</h5>
        <el-button
          class="tst-delete-property-button"
          type="danger"
          text
          @click="
            dialog = false;
            deleteProperty(property.propertyid, property);
          "
        >Delete Property</el-button>
        <el-button class="tst-cancel-delete-button"
                text @click="closeForm()">Cancel</el-button>
      </el-card>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
export default {
  props: {
    property: Object
  },
  data(){
    return{
      loadingFormSubmit: false
    }
  },
  methods: {
    deleteProperty(propertyid, property) {

      this.loadingFormSubmit = true;

      EventService.deleteProperty(propertyid)
        .then(response => {
          if (response.status == 204) {
            this.$store.dispatch("addNotification", {
              type: "success",
              Message: "Property deleted"
            });
          }

          this.closeForm();
        })
        .catch(error => {
           console.log(error);
           this.closeForm();
        });
    },
    closeForm() {
      this.$emit("close-delete-property-form");
    }
  }
};
</script>

<style scoped>
.cont-card {
  max-width: 600px;
}
</style>
